module.exports = __webpack_public_path__ + "img/Home.30bf035d.svg";